import { format, parse } from "date-fns";
import { StorageValue } from "zustand/middleware";

import { type BookingPersist } from "./types";

export const deserializeStore = (str: string | null) => {
  if (!str) return null;

  const { state } = JSON.parse(str);

  return {
    state: { ...state, arrivalDate: new Date(state.arrivalDate) },
  };
};

export const serializeStore = (value: StorageValue<BookingPersist>) =>
  JSON.stringify(value);

export const convertDateToISO = (inputDate: string): string => {
  const parsedDate = parse(inputDate, "dd/MM/yyyy", new Date());
  return format(parsedDate, "yyyy-MM-dd");
};
